import { render, staticRenderFns } from "./RegisterFormFirstStep.vue?vue&type=template&id=2b578caf&"
import script from "./RegisterFormFirstStep.vue?vue&type=script&lang=js&"
export * from "./RegisterFormFirstStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormInput: require('/workspace/components/Form/FormInput.vue').default,FormSelect: require('/workspace/components/Form/FormSelect.vue').default,FormInputDate: require('/workspace/components/Form/FormInputDate.vue').default,FormSelect: require('/workspace/components/Form/FormSelect.vue').default,Form: require('/workspace/components/Form/index.js').default})
